/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class NewUserRequestSubmitDto {
    firstName: string = undefined;
    lastName: string = undefined;
    emailAddress: string = undefined;
    phone: string = undefined;
    division: string = undefined;
    additionalDivisions: string = undefined;
    auth0UserId: string = undefined;
    fullName: string = "";
    recaptchaResponse: string = undefined;
}
